import React from 'react';
import Icon from 'components/AppIcon';
import Button from 'components/ui/Button';

const CTASection = () => {
  return (
    <section className="py-20 lg:py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div 
          className="relative rounded-3xl overflow-hidden shadow-2xl"
          style={{ background: 'linear-gradient(135deg, #96121D 0%, #9B8E57 50%, #C4A556 100%)' }}
        >
          {/* Background Pattern */}
          <div className="absolute inset-0 opacity-10">
            <svg className="w-full h-full" viewBox="0 0 400 400">
              <defs>
                <pattern id="ctaPattern" x="0" y="0" width="40" height="40" patternUnits="userSpaceOnUse">
                  <circle cx="20" cy="20" r="2" fill="white" />
                  <circle cx="5" cy="5" r="1" fill="white" />
                  <circle cx="35" cy="35" r="1" fill="white" />
                </pattern>
              </defs>
              <rect width="100%" height="100%" fill="url(#ctaPattern)" />
            </svg>
          </div>

          {/* Content */}
          <div className="relative z-10 px-8 py-16 lg:py-20 text-center">
            <div className="max-w-4xl mx-auto">
              {/* Icon */}
              <div className="flex justify-center mb-6">
                <div 
                  className="w-20 h-20 rounded-2xl flex items-center justify-center"
                  style={{ backgroundColor: 'rgba(255, 255, 255, 0.2)' }}
                >
                  <Icon name="Rocket" size={40} className="text-white" />
                </div>
              </div>

              {/* Heading */}
              <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6 leading-tight">
                Construisons Ensemble l'Excellence de Demain
              </h2>

              {/* Description */}
              <p className="text-xl lg:text-2xl text-white/90 mb-10 leading-relaxed">
                Que vous soyez un partenaire potentiel, un fournisseur de solutions innovantes, 
                ou une entreprise cherchant des ressources d'hébergement fiables, 
                explorons ensemble comment nous pouvons créer de la valeur mutuelle.
              </p>

              {/* CTA Buttons */}
              <div className="flex flex-col sm:flex-row gap-4 justify-center mb-8">
                <Button
                  size="lg"
                  className="bg-white text-gray-900 font-semibold px-10 py-4 rounded-xl shadow-lg hover:bg-gray-100 transition-all duration-300"
                >
                  <Icon name="Mail" size={20} className="mr-2" />
                  Contactez-Nous
                </Button>
                <Button
                  size="lg"
                  className="border-2 border-white text-white font-semibold px-10 py-4 rounded-xl hover:bg-white/10 transition-all duration-300 backdrop-blur-sm"
                  variant="outline"
                >
                  <Icon name="Download" size={20} className="mr-2" />
                  Dossier Partenariat
                </Button>
              </div>

              {/* Contact Info */}
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 pt-8 border-t border-white/20">
                <div className="flex items-center justify-center space-x-3">
                  <Icon name="Phone" size={24} className="text-white" />
                  <span className="text-white font-medium">+33 1 23 45 67 89</span>
                </div>
                <div className="flex items-center justify-center space-x-3">
                  <Icon name="Mail" size={24} className="text-white" />
                  <span className="text-white font-medium">partenaires@crfperfection.com</span>
                </div>
                <div className="flex items-center justify-center space-x-3">
                  <Icon name="MapPin" size={24} className="text-white" />
                  <span className="text-white font-medium">Paris, France</span>
                </div>
              </div>
            </div>
          </div>

          {/* Decorative Elements */}
          <div className="absolute top-10 left-10 w-24 h-24 rounded-full bg-white/10 blur-2xl"></div>
          <div className="absolute bottom-10 right-10 w-32 h-32 rounded-full bg-white/10 blur-3xl"></div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;